import {
	Component,
	EventEmitter,
	OnInit,
	Output,
	ViewChild,
} from '@angular/core';
import { combineAll, DcBaseComponent } from '@datachain/ui-sdk/common';
import { Store } from '@ngrx/store';
import { firstValueFrom, Observable, takeUntil, tap } from 'rxjs';

import { DcIcons } from '../../../ui/app-dc.icons';
import {
	navigateToSubscriptionCreateFromDatablock,
	SubscriptionSelector,
} from '../../store';
import { SubscriptionListComponent } from '../subscription-list/subscription-list.component';

@Component({
	selector: 'app-subscription-list-wrapper',
	templateUrl: './subscription-list-wrapper.component.html',
	styleUrls: ['./subscription-list-wrapper.component.scss'],
	inputs: ['datablockId', 'datablockLabel', 'selectSubTab'],
})
export class SubscriptionListWrapperComponent
	extends DcBaseComponent
	implements OnInit
{
	protected readonly DcIcons = DcIcons;

	@ViewChild(SubscriptionListComponent)
	private readonly subscriptionListCmp: SubscriptionListComponent | null = null;

	@Output()
	public subscriptionCount = new EventEmitter<number>();

	public vo$: Observable<{
		datablockId: number;
		hasCreatePermission: boolean;
	}>;

	public constructor(
		private readonly store: Store,
		private readonly selector: SubscriptionSelector
	) {
		super();
		this.cmpId = 'subscription-list-wrapper';

		this.vo$ = combineAll({
			datablockId: this.toObservable<number>('datablockId'),
			hasCreatePermission: this.selector.getHasCreatePermission$(),
		});
	}

	public ngOnInit(): void {
		super.ngOnInit();

		this.toObservable<boolean>('selectSubTab')
			.pipe(
				takeUntil(this.onDestroy$),
				tap(() => {
					if (!this.subscriptionListCmp) {
						return;
					}
					this.subscriptionListCmp.grid?.instance.updateDimensions();
				})
			)
			.subscribe();
	}

	public getSubscriptionCount(count: number): void {
		this.subscriptionCount.emit(count);
	}

	public async createNew(): Promise<void> {
		const datablockId = await firstValueFrom(
			this.toObservable<number>('datablockId')
		);
		const datablockLabel = await firstValueFrom(
			this.toObservable<string>('datablockLabel')
		);

		this.store.dispatch(
			navigateToSubscriptionCreateFromDatablock({
				datablockId,
				datablockLabel,
			})
		);
	}
}
